"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckerHelper = void 0;
var CheckerHelper = (function () {
    function CheckerHelper() {
    }
    CheckerHelper.IsArrayOf = function (arr, type, uniqueElements) {
        if (type === void 0) { type = 'string'; }
        if (uniqueElements === void 0) { uniqueElements = true; }
        try {
            for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                var i = arr_1[_i];
                if (typeof (i) !== type)
                    return false;
            }
            if (uniqueElements) {
                var prev = null;
                for (var _a = 0, _b = arr.sort(); _a < _b.length; _a++) {
                    var i = _b[_a];
                    if (i === prev)
                        return false;
                    prev = i;
                }
            }
            return true;
        }
        catch (_c) {
            return false;
        }
    };
    return CheckerHelper;
}());
exports.CheckerHelper = CheckerHelper;
//# sourceMappingURL=CheckerHelper.js.map